// src/sectors/pilates/sessions/components/calendar/TimeCell.jsx
import React from 'react';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

function pad2(n) {
  return String(n).padStart(2, '0');
}
function minToHm(min) {
  const h = Math.floor(min / 60);
  const m = min % 60;
  return `${pad2(h)}:${pad2(m)}`;
}

export function TimeCell({ label, rowIdx, borderColor }) {
  return (
    <MDBox
      sx={{
        p: 0.8,
        borderRight: `1px solid ${borderColor}`,
        borderBottom: `1px solid ${borderColor}`,
        background: rowIdx % 2 ? 'rgba(0,0,0,.03)' : 'transparent',
      }}
    >
      <MDTypography variant="caption" sx={{ fontWeight: 800, opacity: 0.75 }}>
        {minToHm(label)}
      </MDTypography>
    </MDBox>
  );
}
